import { useAuth } from '../context/AuthContext';
import logo from '../components/BeeFluent logos/beefluent_logo_512.png';

export default function Login() {
  const { login, enterGuest } = useAuth();

  return (
    <div className="min-h-screen bg-amber-50 flex items-center justify-center px-4">
      <div className="bg-white rounded-2xl shadow-md p-6 sm:p-8 w-full max-w-md text-center">
        <div className="flex items-center justify-center gap-0 mb-2">
          <img src={logo} alt="BeeFluent logo" className="h-16 w-auto" />
          <h2 className="text-3xl font-bold text-amber-600">BeeFluent</h2>
        </div>
        <p className="text-amber-700 mb-8">Sign in to start learning</p>

        <button
          onClick={login}
          className="w-full flex items-center justify-center gap-3 border border-gray-300 rounded-lg px-4 py-3 hover:bg-gray-50 transition font-medium text-gray-700"
        >
          <svg className="w-5 h-5" viewBox="0 0 21 21" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
            <rect x="1" y="1" width="9" height="9" fill="#f25022" />
            <rect x="1" y="11" width="9" height="9" fill="#00a4ef" />
            <rect x="11" y="1" width="9" height="9" fill="#7fba00" />
            <rect x="11" y="11" width="9" height="9" fill="#ffb900" />
          </svg>
          Sign in with Microsoft
        </button>

        <div className="flex items-center gap-3 my-4">
          <div className="flex-1 h-px bg-amber-100" />
          <span className="text-xs text-amber-400 uppercase tracking-wide">or</span>
          <div className="flex-1 h-px bg-amber-100" />
        </div>

        <button
          onClick={enterGuest}
          className="w-full rounded-lg px-4 py-3 font-medium text-amber-700 hover:bg-amber-50 transition"
        >
          Continue as guest
        </button>
        <p className="text-amber-500 text-xs mt-2">
          Browse public courses — your progress won't be saved.
        </p>
      </div>
    </div>
  );
}
